// useScrollObserver.js - Complete rewrite
import { useState, useEffect } from "react";

export const useScrollObserver = (containerRef, latestResponseRef) => {
  // Start with button visible
  const [showScrollButton, setShowScrollButton] = useState(true);

  useEffect(() => {
    // Find the actual scrollable parent - this is key!
    const findScrollableParent = (element) => {
      if (!element) return document.documentElement;
      
      const style = window.getComputedStyle(element);
      const overflowY = style.getPropertyValue('overflow-y');
      
      if (overflowY === 'auto' || overflowY === 'scroll') {
        return element;
      }
      
      return findScrollableParent(element.parentElement);
    };
    
    // The real scrollable container might be a parent of our ref
    const getScrollableContainer = () => {
      if (!latestResponseRef?.current) return null;
      return findScrollableParent(latestResponseRef.current);
    };
    
    const checkVisibility = () => {
      if (!latestResponseRef?.current) return;
      
      const scrollContainer = getScrollableContainer();
      if (!scrollContainer) return;
      
      const containerRect = scrollContainer.getBoundingClientRect();
      const elementRect = latestResponseRef.current.getBoundingClientRect();
      
      // Is the element bottom within the visible area of the container?
      const isVisible = elementRect.bottom <= containerRect.bottom + 50;
      
      console.log({
        containerBottom: containerRect.bottom,
        elementBottom: elementRect.bottom,
        isVisible
      });
      
      setShowScrollButton(!isVisible);
    };
    
    // Initial check
    checkVisibility();
    
    // Get the actual scrollable container
    const scrollContainer = getScrollableContainer();
    if (!scrollContainer) return;
    
    // Add event listener to the actual scrollable container
    scrollContainer.addEventListener('scroll', checkVisibility);
    window.addEventListener('resize', checkVisibility);
    
    return () => {
      scrollContainer.removeEventListener('scroll', checkVisibility);
      window.removeEventListener('resize', checkVisibility);
    };
  }, [latestResponseRef]);
  
  return { showScrollButton };
};